import React from "react";
import { ArrowRight, ArrowUpRight, Check } from "lucide-react";
import { services, process } from "../data/mock";
import { openContactModal } from "../lib/contactBus";

const inclusions = [
  "In-house design & 3D renderings",
  "DOB filings + permit handling",
  "Licensed structural engineering",
  "Daily site photo logs",
  "Live budget & schedule access",
  "Two-year workmanship guarantee",
  "Single point of contact",
  "Insurance + COI for any building",
];

export default function Services() {
  return (
    <>
      {/* Hero */}
      <section className="max-w-[1480px] mx-auto px-6 lg:px-10 pt-16 pb-16">
        <p className="section-tag mb-4">// CAPABILITIES</p>
        <h1 className="font-display text-[72px] sm:text-[112px] lg:text-[160px] uppercase leading-[0.88] max-w-5xl">
          What we<br /><span className="text-[var(--terracotta)]">build.</span>
        </h1>
        <p className="mt-8 text-[15px] leading-7 text-[var(--slate-700)] max-w-2xl">
          Six capabilities. One ownership model. Each project is delivered by an in-house team — designer, project manager, and crew — all on Edge Developer payroll.
        </p>
      </section>

      {/* Services bento */}
      <section className="max-w-[1480px] mx-auto px-6 lg:px-10 pb-20">
        <div className="grid grid-cols-12 gap-3 lg:gap-4">
          {services.map((s, i) => (
            <div key={s.id} className={`bento-card relative overflow-hidden group min-h-[340px] ${i % 5 === 0 ? "col-span-12 lg:col-span-8" : (i % 5 === 1 ? "col-span-12 lg:col-span-4" : (i % 5 === 2 ? "col-span-6 lg:col-span-4" : (i % 5 === 3 ? "col-span-6 lg:col-span-4" : "col-span-12 lg:col-span-4")))}`}>
              <img src={s.image} alt={s.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--slate-950)]/90 via-[var(--slate-950)]/30 to-transparent" />
              <div className="relative h-full flex flex-col justify-between p-6 text-[var(--off-white)]">
                <div className="flex items-center justify-between">
                  <span className="font-mono-sans text-[10px] text-[var(--terracotta-light)]">// {s.id}</span>
                  <span className="font-mono-sans text-[9.5px] bg-[var(--terracotta)] px-2 py-1">{s.tag}</span>
                </div>
                <div>
                  <h3 className="font-display text-[34px] lg:text-[44px] uppercase leading-[0.95]">{s.title}</h3>
                  <p className="text-[13px] text-[var(--slate-300)] mt-3 max-w-md">{s.body}</p>
                  <button onClick={openContactModal} className="mt-5 inline-flex items-center gap-2 font-mono-sans text-[11px] font-semibold tracking-widest text-[var(--terracotta-light)] hover:text-[var(--off-white)] transition-colors">
                    INQUIRE <ArrowUpRight size={14} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Whats included */}
      <section className="bg-[var(--slate-950)] text-[var(--off-white)] py-20">
        <div className="max-w-[1480px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-12 gap-10">
            <div className="col-span-12 lg:col-span-5">
              <p className="section-tag !text-[var(--terracotta-light)] mb-3">// EVERY PROJECT INCLUDES</p>
              <h2 className="font-display text-[48px] sm:text-[64px] uppercase leading-[0.95]">No hidden<br /><span className="text-[var(--terracotta)]">add-ons.</span></h2>
              <p className="text-[14px] text-[var(--slate-300)] mt-6 leading-7 max-w-md">
                The line items below are baked into every Edge Developer contract. Not upgrades. Not options. Standard.
              </p>
              <button onClick={openContactModal} className="btn-terracotta mt-8">Request A Quote <ArrowRight size={15} /></button>
            </div>
            <ul className="col-span-12 lg:col-span-7 grid sm:grid-cols-2 gap-3">
              {inclusions.map((it) => (
                <li key={it} className="flex items-start gap-3 border border-[var(--slate-700)] p-4 hover:border-[var(--terracotta)] transition-colors">
                  <Check size={18} className="text-[var(--terracotta)] mt-0.5 shrink-0" />
                  <span className="text-[13.5px]">{it}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="max-w-[1480px] mx-auto px-6 lg:px-10 py-20">
        <p className="section-tag mb-3">// THE PROCESS</p>
        <h2 className="font-display text-[48px] sm:text-[64px] uppercase leading-[0.95] mb-10">Five phases. <span className="text-[var(--terracotta)]">One team.</span></h2>
        <div className="grid grid-cols-1 md:grid-cols-5 border-t border-l border-[var(--slate-300)]">
          {process.map((p) => (
            <div key={p.num} className="border-b border-r border-[var(--slate-300)] p-6 hover:bg-[var(--bg-secondary)] transition-colors">
              <p className="font-display text-[64px] text-[var(--terracotta)]">{p.num}</p>
              <h3 className="font-display text-[24px] uppercase mt-2">{p.title}</h3>
              <p className="text-[12.5px] text-[var(--slate-700)] mt-3 leading-6">{p.body}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
